module.exports = __webpack_public_path__ + "static/media/icon-arrow-down.e393bcc6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/imgs/icon-arrow-down.svg
// module id = 285
// module chunks = 0